import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// the maps components need the global `google` before rendering, as the old <script> in index.html guaranteed
function loadGoogleMaps(apiKey: string | undefined): Promise<void> {
  if (!apiKey) {
    return Promise.resolve();
  }
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?libraries=places,drawing,geometry&key=${encodeURIComponent(apiKey)}`;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });
}

loadGoogleMaps(environment.googleMap?.api_key)
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
